import getConfig from 'next/config';

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

interface IResponse {
  districtCode: string;
}

export const GET_DISTRICT_CODE_ENDPOINT_URL = '/v1/auth/districtcode';
const URL = `${publicRuntimeConfig.GET_DISTRICT_CODE_API_BASE_URL}${GET_DISTRICT_CODE_ENDPOINT_URL}?sitecode=`;
const API_KEY = serverRuntimeConfig.AWS_API_KEY;
export const getDistrictCode = async (siteCode: string) =>
  new Promise<IResponse>((resolve, reject) => {
    fetch(URL + siteCode, {
      mode: 'cors',
      headers: {
        'x-api-key': API_KEY,
        'content-type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then(async response => {
        if (response.status >= 200 && response.status < 400) {
          const data = await response.json();
          resolve(data);
        } else {
          const errors = await response.json();
          reject(errors);
        }
      })
      .catch(async error => {
        const errors = await error.json();
        reject(errors);
      });
  });
